export const LaunchDates = {
  octFirst2020: new Date('2020-10-01T14:07:00.000Z'),
  febFirst2021: new Date('2021-02-01T14:07:00.000Z'),
  seasonalWineClub: new Date('2021-05-01T07:00:00.00Z'),
};
